import React from 'react';
import { connect } from 'react-redux';
import { trans } from '../../../localization/language';
import { ACCOUNT_TYPE } from '../../../constants';
import TwoStepVerification from '../verification/TwoStepVerification';

class TwoStepVerificationMobile extends React.Component {
	render() {
		var title = (this.props.userInfo.mobile_no === '') ? trans('bind_mobile_title') : trans('change_mobile_title');
		return (
			<TwoStepVerification title={title} ac_type={ACCOUNT_TYPE.MOBILE} />
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo
	}
}

export default connect(mapStateToProps)(TwoStepVerificationMobile);


// WEBPACK FOOTER //
// ./app/components/security/mobile/TwoStepVerificationMobile.js